// 2025(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

export const input_check_many = function(selector) {

    document.querySelectorAll(selector).forEach(el => {
        const target = el.dataset.targetName;

        el.addEventListener('change', function() {
            const checkboxes = document.querySelectorAll('input[type="checkbox"][name="' + target + '"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = el.checked;
                checkbox.dispatchEvent(new Event('change'));
            });
        });
    });

};